import React, { useEffect, useState } from 'react';
import { useForm } from '../forms/useForm';
import moment from 'moment';
import 'moment/locale/es';
import { sendRequest } from "../../hooks/requests/useRequest";
import { ConfigServer } from "../../data/config";

export const useReportCxc = () => {

    const [reports, setReports] = useState([]);
    const [isDownloading, setIsDownloading] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");

    //? TOAST ALERT 
    const [showToast, setShowToast] = useState(false);
    const [toastType, setToastType] = useState("info");
    const [toastTitle, setToastTitle] = useState("");
    const [toastMessage, setToastMessage] = useState("");

    const [formValues, handleInputChange] = useForm({
        start_date: "",
        end_date: ""
    });

    const {
        start_date,
        end_date
    } = formValues;


    //#region ALERT GLOBAL 
    const showToastAlert = (
        type = "info",
        title = "",
        message = ""
    ) => {

        setToastType(type);
        setToastTitle(title);
        setToastMessage(message);
        setShowToast(true);

    };

    const closeToastAlert = () => {

        setShowToast(false);
        setToastTitle("");
        setToastMessage("");

    };
    //#endregion

    
    //? LISTAR REPORTES GENERADOS
    
    const getReportsCxC = async () => {
        let requestOptions = {
            method: 'GET'
        };

        const respuesta = await sendRequest(
            requestOptions,
            "Reports/ListReportCxCDownloads"
        );

        if (respuesta.code === 200) {
            setReports(respuesta.data ?? []);
        }
    };


    //#region generate report

    const generateReportCxC = async () => {

        if (!start_date || !end_date) {
            showToastAlert("warning", "Aviso", "Selecciona la fecha de inicio y fecha de cierre.");
            return;
        }

        if (moment(start_date).isAfter(moment(end_date))) {
            showToastAlert("warning", "Aviso", "La fecha de inicio no puede ser mayor a la fecha de cierre.");
            return;
        }

        setIsDownloading(true);

        let requestOptions = {
            method: 'POST'
        };

        try {

            const respuesta = await sendRequest(requestOptions, `Reports/GenerateReportCxC/${start_date}/${end_date}`);

            if (respuesta.code === 200) {
                showToastAlert("success", "Reporte", "El reporte se está generando.");
                await getReportsCxC();
            }
            else {
                showToastAlert("error", "Error", respuesta.data?.msg || "No fue posible generar el reporte");
            }

        }
        catch (error) {
            // console.error("Error al generar reporte CxC:", error);
        }
        finally {
            setIsDownloading(false);
        }
    };
    //#endregion


    //#region DOWNLOAD REPORT
    const downloadReportCxC = async (row) => {
        if (!row || Number(row.progress) < 100) {
            return;
        }

        let token = localStorage.getItem("token");
        await fetch(ConfigServer.serverUrl + `/api/Reports/DownloadReportCxCFile/${row.id_report_cxc_download}`, {
            method: 'GET',
            headers: new Headers({
                "Authorization": "Bearer " + token,
                "Content-Type": "application/vnd.ms-excel"
            })
        })
            .then(response => {
                if (response.status !== 200) {
                    showToastAlert("warning", "Error", "No se descargo el archivo excel");
                    return;
                }

                return response.blob();
            })
            .then(blob => {
                var url = window.URL.createObjectURL(blob);

                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "Reporte global de cuentas por cobrar.xlsx");
                document.body.appendChild(link);
                link.style.display = 'none';
                link.click();
            });
        }
    

    //#endregion

    useEffect(() => {
        getReportsCxC();
    }, []);


    //#region UPDATE PROGRESS AUTOMATICALLY
    useEffect(() => {
        const hasPending = reports.some(
            x => Number(x.progress) < 100
        );

        if (!hasPending) {
            return;
        }

        const interval = setInterval(() => {
            getReportsCxC();
        }, 5000);

        return () => clearInterval(interval);

    }, [reports]);

    //#endregion

    //#region Search
    const filteredReports = reports.filter(item => {

        if (!searchTerm) {
            return true;
        }

        const search = searchTerm.toLowerCase();

        return Object.values(item).some(value =>
            String(value ?? "")
                .toLowerCase()
                .includes(search)
        );
    });

    //#endregion


    const isButtonDisabled =
        !start_date ||
        !end_date ||
        isDownloading;


    return {
        start_date,
        end_date,
        handleInputChange,
        reports,
        filteredReports,
        isDownloading,
        isButtonDisabled,
        generateReportCxC,
        downloadReportCxC,
        getReportsCxC,
        searchTerm,
        setSearchTerm,
        
        //? TOAST ALERT
        showToast,
        toastType,
        toastTitle,
        toastMessage,
        showToastAlert,
        closeToastAlert,
    };
};